import React from "react";
import { DestinationTypeEnum } from "../../../../../enums/destination";
import {
  AllDestinations,
  GoogleDocsDestination,
  ShopifyDestination,
  WordPressDestination,
} from "../../../../../models";

export const DestinationURLColumn = ({
  destination,
}: {
  destination: AllDestinations;
}) => {
  if (destination.destinationTypeId === DestinationTypeEnum.GOOGLE_DOCS) {
    const { googleEmail, folderId, folderName, needsReconnect } = (
      destination as GoogleDocsDestination
    ).destination;
    if (!googleEmail || needsReconnect) {
      return <div className="text-gray-500">Not connected</div>;
    }
    return (
      <div
        className="truncate overflow-hidden text-primary w-max"
        onClick={(e: any) => {
          e.stopPropagation();
          window.open(
            folderId
              ? `https://drive.google.com/drive/folders/${folderId}`
              : "https://drive.google.com/",
            "_blank"
          );
        }}
      >
        Google Drive / {folderName} ({googleEmail})
      </div>
    );
  }

  let url: string;
  if (destination.destinationTypeId === DestinationTypeEnum.SHOPIFY) {
    const shopifyDestination = destination as ShopifyDestination;
    url = `https://${shopifyDestination.destination.storeName}.myshopify.com/`;
  } else {
    const wordpressDestination = destination as WordPressDestination;
    url = wordpressDestination.destination.url;
  }

  return (
    <div
      className="truncate overflow-hidden text-primary w-max"
      onClick={(e: any) => {
        e.stopPropagation();
        window.open(url, "_blank");
      }}
    >
      {url}
    </div>
  );
};
